const filesTypography = {
  label: 'Archivos de soporte de GEEQUIP'
};

export default filesTypography;
